var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteboard = function SvgWhiteboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 3.75H3v10.5h18zM3 2.25a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.305 14.315a.75.75 0 0 1 .38.99l-3 6.75a.75.75 0 0 1-1.37-.61l3-6.75a.75.75 0 0 1 .99-.38M14.695 14.315a.75.75 0 0 0-.38.99l3 6.75a.75.75 0 0 0 1.37-.61l-3-6.75a.75.75 0 0 0-.99-.38",
    clipRule: "evenodd"
  })));
};
export default SvgWhiteboard;